import { useEffect } from "react";

export default function useReveal() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".reveal"));
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("in-view"));
      return;
    }

    // Immediately mark already-visible elements (handles initial scroll position).
    const vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) {
        el.classList.add("in-view");
      }
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: "0px 0px -10% 0px" }
    );
    els.forEach((el) => {
      if (!el.classList.contains("in-view")) io.observe(el);
    });

    // Safety fallback: reveal everything after 1.2s.
    const t = setTimeout(() => {
      els.forEach((el) => el.classList.add("in-view"));
    }, 1500);

    return () => {
      io.disconnect();
      clearTimeout(t);
    };
  }, []);
}
